module.exports = __webpack_public_path__ + "static/media/tt.795c9b17.webp";